import Format from 'services/Format'

export default {
  methods: {
    showBoolean(boolean) {
      let title = boolean ? 'online' : 'offline'
      let color = boolean ? '#9fc868' : '#be636a'
      return `<figure title="${title}" style="width:.8rem;height:.8rem;border-radius:100%;background-color:${color};"></figure>`
    },
    showDate(date) {
      return Format.date(date)
    },
    showDateTime(date) {
      return Format.date(date, 'YYYY-MM-DD HH:mm')
    },
    showDateFromEpoch(date) {
      return this.showDate(Format.dateFromEpoch(date))
    },
    showDateTimeFromEpoch(date) {
      return this.showDateTime(Format.dateFromEpoch(date))
    },
    showMoney(money) {
      return Format.money(money)
    },
    showRepeatsType(type) {
      return Format.repeatsType(type)
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/mixins/list-helpers.js